import { buildApiUrl } from './apiBase';
import { createApiHttpClient } from './httpClient';

export const PROCESS_ENGINE_API_BASE = '/api/engine';

export const buildProcessEngineUrl = (path: string) => buildApiUrl(PROCESS_ENGINE_API_BASE, path);

export const processEngineHttp = createApiHttpClient();
